import React from "react";
import { isSet } from "../../../../../../utils/commonUtils";
import FormInputs from "../../../../../../components/UI/FormInputs";

const AudiogramTable = ({
    formData = {},
    changeHandler,
    readOnly = false,
    validation = {},
    col = 'col-12',
    ...props
}) => {
    const frequencies = [500, 1000, 2000, 3000, 4000, 6000, 8000];
    const ears = ['left', 'right'];
    // Get field name for a specific ear and frequency
    const getFieldName = (ear, frequency) => `audiogram_${ear}_${frequency}`;
    // Get value for a specific ear and frequency
    const getValue = (ear, frequency) => {
        const fieldName = getFieldName(ear, frequency);
        const value = isSet(formData[fieldName], '');
        if (value === '' || value === null || value === undefined) return '';
        const numValue = parseFloat(value);
        return isNaN(numValue) ? '' : numValue;
    };
    // Calculate average for an ear
    const calculateAverage = (ear) => {
        const values = frequencies.map(freq => getValue(ear, freq)).filter(v => v !== '');
        if (values.length === 0) return '';
        const sum = values.reduce((acc, val) => acc + val, 0);
        return (sum / values.length).toFixed(2);
    };
    // Get color class and style based on value
    const getRangeStyle = (value) => {
        if (value === '' || value === null || value === undefined) {
            return { backgroundColor: '#ffffff' }; // white for empty/light
        }
        const numValue = parseFloat(value);
        if (numValue <= 20) {
            return { backgroundColor: '#ffffff', }; // white
        }
        if (numValue <= 35) {
            return { backgroundColor: '#E1F8F0'}; // light green
        }
        if (numValue <= 45) {
            return { backgroundColor: '#E8F4D9' }; // light yellow-green/olive
        }
        if (numValue <= 50) {
            return { backgroundColor: '#FEFADB' }; // light yellow-green/olive
        }
        if (numValue <= 65) {
            return { backgroundColor: '#FEFADB' }; // light yellow
        }
        if (numValue <= 80) {
            return { backgroundColor: '#F7F2E6' }; // light orange
        }
        return { backgroundColor: '#ffeaa7' }; // light orange
    };
    const getRangeClass = (value) => {
        if (value === '' || value === null || value === undefined) return 'range-light';
        const numValue = parseFloat(value);
        if (numValue <= 20) return 'range-light';
        if (numValue <= 35) return 'range-green';
        if (numValue <= 50) return 'range-olive';
        if (numValue <= 65) return 'range-yellow';
        return 'range-orange';
    };
    
    // Handle value change
    const handleChange = (ear, frequency, value) => {
        if (readOnly || !changeHandler) return;
        const fieldName = getFieldName(ear, frequency);
        // Pass key (fieldName), value, and optional object (empty object for now)
        changeHandler(fieldName, value, {});
    };
    
    return (
        <>
            <style>{`
                .freq-cell {
                    padding: 0.25rem;
                    text-align: center;
                    min-width: 50px;
                    display: inline-block;
                    width: 100%;
                    border-radius: 2px;
                }
                .sh_audiogramtable td {
                    padding: 0.5rem;
                    vertical-align: middle;
                }
                .sh_audiogramtable th {
                    padding: 0.5rem;
                    font-weight: 600;
                }
            `}</style>
            <div className={`${col} py-0 px-0`}>
                        <table className="sh_tablenew sh_audiogramtable">
                        <thead>
                            <tr>
                                <th></th>
                                {frequencies.map(freq => (
                                    <th key={freq} className="text-center">{freq}</th>
                                ))}
                                <th className="text-center">AVERAGE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ears.map(ear => {
                                const earLabel = ear.charAt(0).toUpperCase() + ear.slice(1);
                                const average = calculateAverage(ear);
                                return (
                                    <tr key={ear}>
                                        <td className="">{earLabel}</td>
                                        {frequencies.map(freq => {
                                            const value = getValue(ear, freq);
                                            const fieldName = getFieldName(ear, freq);
                                            const rangeClass = getRangeClass(value);
                                            const rangeStyle = getRangeStyle(value);
                                            const hasError = isSet(validation[fieldName], '') !== '';
                                            
                                            return (
                                                <td key={freq} className="">
                                                   <div className={`freq-cell border ${rangeClass}`} style={rangeStyle}>
                                                            <FormInputs
                                                                type="TextInput"
                                                                name={fieldName}
                                                                id={fieldName}
                                                                value={value !== '' ? value : ''}
                                                                changeHandler={(val) => handleChange(ear, freq, val)}
                                                                readOnly={readOnly}
                                                                className="form-control text-center border-0 p-0"
                                                                style={{
                                                                    backgroundColor: rangeStyle.backgroundColor,
                                                                    textAlign: 'center',
                                                                    minHeight: 'auto',
                                                                    height: 'auto',
                                                                    padding: '0.25rem',
                                                                    width: '100%'
                                                                }}
                                                            />
                                                        </div>
                                                    
                                                    {hasError && (
                                                        <div className="text-danger small mt-1">
                                                            {validation[fieldName]}
                                                        </div>
                                                    )}
                                                </td>
                                            );
                                        })}
                                        <td className="">
                                            {readOnly ? (
                                                <div className={`freq-cell ${getRangeClass(average)}`} style={getRangeStyle(average)}>
                                                    {average !== '' ? average : ''}
                                                </div>
                                            ) : (
                                                <div className={`freq-cell border ${getRangeClass(average)}`} style={getRangeStyle(average)}>
                                                    <FormInputs
                                                        type="TextInput"
                                                        readOnly={readOnly}
                                                        disabled={true}
                                                        value={average !== '' ? average : ''}
                                                        className="form-control text-center border-0 p-0"
                                                        style={{
                                                            background: 'transparent',
                                                            textAlign: 'center',
                                                            minHeight: 'auto',
                                                            height: 'auto',
                                                            padding: '0.25rem',
                                                            width: '100%'
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        </table>
                </div>
        </>
    );
};

export default AudiogramTable;

